// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"768225e5","542":"4104c834","640":"f83b1d9e","695":"0d377b81","787":"898bfd65","820":"63b53168","888":"a31e41cd","961":"58cd9b33"}[chunkId] + ".chunk.js";
};